var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-text-field',_vm._b({directives:[{name:"money",rawName:"v-money",value:(_vm.money),expression:"money"}],attrs:{"value":_vm.formattedValue},on:{"input":_vm.handleInput}},'v-text-field',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }